import BeatLoader from 'react-spinners/BeatLoader'; //NOSONAR
import { APP_COLOR } from './Common.constants';

interface LoaderProps {
  loading: boolean;
  size?: number;
}

const DEFAULT_LOADER_SIZE = 15;

export default function Loader({
  loading,
  size = DEFAULT_LOADER_SIZE,
}: LoaderProps) {
  return (
    <BeatLoader
      color={APP_COLOR['main-ui-blue']}
      loading={loading}
      size={size}
    />
  );
}
